// @flow

import React, { Component } from 'react';
import { get } from 'lodash';
import { css } from 'react-emotion';
import { parse } from 'qs';
import { withRouter } from 'react-router-dom';
import type { Location } from 'react-router-dom';
import { Query } from 'react-apollo';
import { components, elements, colors } from '@peachjar/components';

import ConfirmSetup from './ConfirmSetupTab';
import WhileYouWait from '../components/WhileYouWaitTab';
import SCHOOL_OR_DISTRICT_REGISTRATION_QUERY from '../utils/schoolOrDistrictRegistration.query';

const { platinum } = colors;

const { Tabber, Stepper, LoadingIndicators } = components;

const { SpinnerLarge } = LoadingIndicators;
const { Headline1 } = elements.typography;

const styles = {
  confirmSetupContainer: css`
    flex: 1 1 auto;
    background-color: ${platinum};
    padding: '2rem 0';
  `,
};

type Props = {|
  +location: Location,
|};

type State = {|
  tabView: number,
|};

class ConfirmSetupContainer extends Component<Props, State> {
  refetch: () => void;

  constructor(props) {
    super(props);

    this.state = {
      tabView: 1,
    };
  }

  generateTabs = tabView => {
    const tabs = [
      {
        id: 1,
        isActive: tabView === 1,
        icon: 'Confirm',
        label: 'Confirm',
        labelSubText:
          'the setup steps below. Read and confirm the Policies and Recommendations.',
        onClickHandler: () => {
          this.setState({ tabView: 1 });
          this.refetchRegistration();
        },
        isLocked: false,
      },
      {
        id: 2,
        isActive: tabView === 2,
        icon: 'Download',
        label: 'While you wait',
        labelSubText:
          'to be verified, download three templates and start exploring Peachjar.',
        onClickHandler: () => {
          if (this.isReadOnly) {
            this.setState({ tabView: 2 });
          }
        },
        isLocked: !this.isReadOnly,
      },
    ];
    return tabs;
  };

  handleContinue = () => this.setState({ tabView: this.state.tabView + 1 });

  render() {
    const { tabView } = this.state;
    const {
      location,
      ncesDistrictId,
      setupProgress,
      refetchRegistration,
    } = this.props;
    this.refetchRegistration = refetchRegistration;
    // if each of these is true, then the district has already signed off. Thus, read-only checkboxes.
    const {
      isSiteLinked,
      haveStaffBeenTrained,
      haveOrgsBeenEmailed,
      haveParentsBeenEmailed,
    } = setupProgress;
    this.isReadOnly =
      !!isSiteLinked &&
      !!haveStaffBeenTrained &&
      !!haveOrgsBeenEmailed &&
      !!haveParentsBeenEmailed;

    return (
      <div className={styles.goLiveContainer}>
        <div className="container">
          <Headline1 className="mb-4 mt-2">Confirm Setup</Headline1>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
            }}
          >
            <Tabber tabs={this.generateTabs(tabView)} />
          </div>

          <div>
            {tabView === 1 && (
              <ConfirmSetup
                ncesDistrictId={ncesDistrictId}
                setupProgress={setupProgress}
                handleContinue={this.handleContinue}
              />
            )}
            {tabView === 2 && <WhileYouWait />}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ConfirmSetupContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/confirm/containers/ConfirmSetupContainer.jsx